$(function () {

    const NAVBAR_HEIGHT = 48;

    $(window).one('load', function () {
        var $hero = $('#hero-banner');
        var $headerNav = $('#header-nav');
        var $spacer = $headerNav.next('.navbar-spacer');

        //var isInsideBannerPresent = $spacer.next().is('.widget-cta-full');

        //if (!isInsideBannerPresent) {
        //  $spacer.css('padding-top', NAVBAR_HEIGHT);
        //}

        //$('#Home #header-nav').affix({
        //    offset: {
        //        //top: $hero.outerHeight(true) / 2
        //    }
        //});

        //if ($('body').not(document.getElementById("Home"))) {

        //    if (isInsideBannerPresent) {
        //        $headerNav.affix({
        //            offset: {
        //                //top: $spacer.next('.widget-cta-full').outerHeight(true)
        //            }
        //        });
        //    } else {
        //        $headerNav.affix({
        //            offset: {
        //                //top: -NAVBAR_HEIGHT
        //            }
        //        });
        //    }

        //}


        //$headerNav.affix({
        //    offset: {
        //        top: 48
        //    }
        //});

    });

    var $footer = $('footer');
    var $bottomTextBanner = $('.widget-text-banner').last();

    $('.widget-one-services .sticky').affix({
        offset: {
            top: 25 + NAVBAR_HEIGHT,
            bottom: $footer.outerHeight(true) + $bottomTextBanner.outerHeight(true) + 20
        }
    }).on('affix.bs.affix', function () { // before affix
        $(this).css({
            /*'top': headerHeight,*/    // for fixed height
            'width': $(this).parent().outerWidth(),  // variable widths
            'position': 'fixed'
        });
    });

    $('.scroll-down').click(function () {
        var $target = $(this).closest(".widget-cta-full").next();

        $('html,body').animate({
            scrollTop: $target.offset().top
        }, 1000);

    });

    $('#videoModal').on('show.bs.modal', function (event) {
        var video = $(event.relatedTarget).data('video');

        var $iframeWrapper = $("<div>");
        $iframeWrapper.addClass("iframe-wrapper");

        var $iframe = $("<iframe>");
        $iframe.attr('src', video + "?enablejsapi=1&autoplay=1&rel=0&color=white");

        $iframe.appendTo($iframeWrapper);

        var modal = $(this);
        modal.find('.iframe-ph').replaceWith($iframeWrapper);
    });

    $('#videoModal').on('hidden.bs.modal', function () {
        var $iframePH = $("<div>");
        $iframePH.addClass("iframe-ph");

        var modal = $(this);
        modal.find('.iframe-wrapper').replaceWith($iframePH);
    })

    var jumplinks = $(".widget-jumplinks:first");
    if (jumplinks.length) {
        //create the jumplinks
        var jumplinksList = jumplinks.find(".jumplinks-list:first");
        var widgets = $("[data-jumplink]").filter(function (index, el) {
            var hasJumplink = $(el).data("jumplink") && $(el).attr("id");
            if (!hasJumplink) return false;
            var jumplink = $("<a>", {
                "href": "#" + $(el).attr("id"),
                "text": $(el).data("jumplink")
            });
            jumplink.click(function (e) {
                console.log("jumplink clicked");
                var targetHref = jQuery(this).attr("href");
                if (!targetHref || targetHref.length < 3) return;
                e.preventDefault();
                var el = jQuery(targetHref);
                if (el.length) {
                    var offsetAdjust = 54; //jumplinks.length ? smallHeader.outerHeight() + jumplinks.outerHeight() : 0;
                    $("html, body").animate({ scrollTop: el.offset().top - offsetAdjust });
                }
            });
            var li = $("<li>");
            li.append(jumplink);
            jumplinksList.append(li);
        });
        jumplinks.show();
        //if ($("body").data("enablejumplink")) {
        //    //smallHeader.css({ position: "fixed", "margin-top": -smallHeader.outerHeight() + "px" });
        //    //*smallHeader.show();
        //    //var smallHeaderfix = $('<div class="smallHeader-replace">').height(smallHeader.outerHeight(true));
        //    //smallHeader.after(smallHeaderfix);
        //    //*header.hide();
        //    //*header.css({ marginTop: -header.outerHeight() });
        //    var $fix = $('<div class="affix-HeaderHeight-fix">').height(header.outerHeight(true));
        //    header.css({ position: "absolute", "margin-top": 0 });
        //    header.after($fix);
        //    jumplinks.on('affix.bs.affix', function () {
        //        jumplinks.stop(true);
        //        jumplinks.css({ position: "fixed", "top": smallHeader.outerHeight(), "left": 0 });
        //        if ($('.affix-height-fix').length < 1) {
        //            var $fix = $('<div class="affix-height-fix">').height(jumplinks.outerHeight(true));
        //            jumplinks.after($fix);
        //        } else {
        //            $('.affix-height-fix').height(jumplinks.outerHeight(true));
        //            jumplinks.after($('.affix-height-fix'));
        //        }
        //    });
        //    jumplinks.on('affix-top.bs.affix', function () {
        //        jumplinks.stop(true);
        //        $('.affix-height-fix').remove();
        //        jumplinks.css({ position: "relative", "top": "" });
        //        //  smallHeader.animate({ bottom: smallHeader.outerHeight() + "px" }, 400, function () { });
        //    });
        //    jumplinks.affix({
        //        offset: {
        //            top: function () {
        //                return ($('.affix-height-fix').length ? $('.affix-height-fix').position().top : jumplinks.position().top) - +smallHeader.outerHeight();
        //                //smallHeader.is(":visible") ? smallHeader.outerHeight() : header.outerHeight();
        //            }
        //        }
        //    });
        //    smallHeader.click(function () {
        //        if (jumplinks.hasClass("affix")) {
        //            jumplinks.animate({ top: 0 }, { duration: 200, queue: false });
        //        }
        //        smallHeader.animate({
        //            marginTop: -smallHeader.outerHeight()
        //            //, opacity: 0
        //        }, {
        //            queue: false, duration: 200, complete: function () { //callback
        //                // smallHeader.css({ marginTop: 0, opacity: 1 });
        //                smallHeader.hide();
        //                header.css({ position: "fixed" });
        //                header.css({ marginTop: -header.outerHeight() });
        //                header.show();
        //                if (jumplinks.hasClass("affix")) {
        //                    jumplinks.animate({ top: header.outerHeight() }, {
        //                        duration: 300, queue: false, complete: function () {
        //                            if (!jumplinks.hasClass("affix")) {
        //                                jumplinks.css({ position: "relative", "top": "" });
        //                            }
        //                        }
        //                    });
        //                }
        //                header.animate({ marginTop: 0 }, {
        //                    duration: 300, queue: false, complete: function () { //callback
        //                        isHeaderExpanded = true;
        //                    }
        //                });
        //            }
        //        });
        //    });
        //    var headerScrollTimeout = undefined;
        //    $(window).scroll(function () {
        //        // hideSearchInput();
        //        //if (bookNowBtn.hasClass("booknow-open")) {
        //        //    bookNowBtn.removeClass("booknow-open");
        //        //    bookNowPopup.slideUp();
        //        //}
        //        if ($(window).scrollTop() >= header.outerHeight() + 100) {
        //            if (!header.data("isfixed")) {
        //                //
        //                //
        //                // hide it and show the small header
        //                header.data("isfixed", true);
        //                // header.hide();
        //                header.css({ position: "absolute", "margin-top": 0 });
        //                smallHeader.show();
        //                smallHeader.animate({
        //                    marginTop: 0
        //                    //, opacity: 0
        //                }, {
        //                    queue: false,
        //                    complete: function () { //callback
        //                    }
        //                });
        //            }
        //        } else {
        //            if (header.data("isfixed")) {
        //                header.data("isfixed", false);
        //                smallHeader.animate({
        //                    marginTop: -smallHeader.outerHeight()
        //                    //, opacity: 0
        //                }, {
        //                    queue: false, duration: 200, complete: function () { //callback
        //                        // smallHeader.css({ marginTop: 0, opacity: 1 });
        //                        smallHeader.hide();
        //                        header.css({ marginTop: 0, position: "absolute" });
        //                        header.show();
        //                    }
        //                });
        //            }
        //            // show the header, hide the small one
        //        }
        //        clearTimeout(headerScrollTimeout);
        //        headerScrollTimeout = setTimeout(function () {
        //            //if ($('.affix-HeaderHeight-fix').length) {
        //            //}
        //            //*smallHeader.css({ position: "fixed" });
        //            //*smallHeader.show();
        //            //var smallHeaderfix = $('<div class="smallHeader-replace">').height(smallHeader.outerHeight(true));
        //            //smallHeader.after(smallHeaderfix);
        //            //*header.hide();
        //            //*header.css({ marginTop: -header.outerHeight() });
        //            //
        //            if (isHeaderExpanded) {
        //                isHeaderExpanded = false;
        //                if (jumplinks.hasClass("affix")) {
        //                    jumplinks.animate({ top: 0 }, { duration: 200, queue: false });
        //                }
        //                header.animate({ marginTop: -header.outerHeight() }, {
        //                    duration: 200, queue: false, complete: function () {
        //                        // header.hide();
        //                        header.css({ position: "absolute", "margin-top": 0 });
        //                        smallHeader.show();
        //                        smallHeader.animate({
        //                            marginTop: 0
        //                            //, opacity: 0
        //                        }, {
        //                            queue: false,
        //                            complete: function () { //callback
        //                            }
        //                        });
        //                        if (jumplinks.hasClass("affix")) {
        //                            jumplinks.animate({ top: smallHeader.outerHeight() },
        //                                {
        //                                    queue: false,
        //                                    complete: function () {
        //                                        if (!jumplinks.hasClass("affix")) {
        //                                            jumplinks.css({ position: "relative", "top": "" });
        //                                        }
        //                                    }
        //                                });
        //                        }
        //                    }
        //                });
        //            }
        //        }, 0);
        //    });
        //} // end enable header affix
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
            { threshold: [1] }
        );

        observer.observe(jumplinks.get()[0]);
    }// end enable header animation


    $('.tab-pane').each(function () {
        var $this = $(this);
        var $navTabs = $this.parents(".widget-tabs").first().find(".nav-tabs");
        var navTitle = $this.data("tab");
        var navID = $this.attr("id");
        //need this
        //<li role="presentation" class="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab">Home</a></li>

        var $newNavTab = $($.parseHTML('<li></li>')).attr("role", "presentation").append(
            $($.parseHTML('<a></a>'))
                .attr({ "href": '#' + navID, "aria-controls": navID, "role": "tab", "data-toggle": "tab" })
                .text(navTitle)
        );

        $navTabs.append($newNavTab);
    });

    $(".nav-tabs").each(function () {
        $(this).children("li").first().addClass("active");
    });

    $(".tab-content").each(function () {
        $(this).children().first().addClass("active in");
    });

});



$('#biosModal').on('show.bs.modal', function (event) {
    var bio = $(event.relatedTarget);
    var bioName = bio.data('name');
    var bioPosition = bio.data('position');
    var bioText = bio.data('bio');
    var bioImage = bio.data('image');
    var bioQuote = bio.data('quote');
    var bioCompany = bio.data('company');

    var modal = $(this);
    modal.find('.bios-modal-image').attr('src', bioImage);
    modal.find('.bios-modal-name').text(bioName);
    modal.find('.bios-modal-position').text(bioPosition);
    modal.find('.bios-modal-bio').html(bioText);
    modal.find('.bios-modal-quote').html(bioQuote);
    modal.find('.bios-modal-company').html(bioCompany);
});

$('#biosModal').on('hidden.bs.modal', function () {
    var modal = $(this);
    modal.find('.bios-modal-image').removeAttr('src');
    modal.find('.bios-modal-name').empty();
    modal.find('.bios-modal-position').empty();
    modal.find('.bios-modal-bio').empty();
    modal.find('.bios-modal-quote').empty();
    modal.find('.bios-modal-company').empty();
});

var $grid = $('.isotope-grid').isotope({

    itemSelector: '.grid-item',
    masonry: {
        columnWidth: 170,
        fitWidth: true,
        rowHeight: 170,
        gutter: 30
    }
});

$grid.imagesLoaded().progress(function () {
    $grid.isotope('layout');
});

$('.header-search-toggler').on('click', function (event) {
    $('.header-search').toggleClass('show');
    $(this).toggleClass('show');
});

$('.widget-service-detail [data-toggle="collapse"]').click(function () {
    $('.collapse.in').collapse('hide');
    $(this).closest('.service-cell').toggleClass("triangle");
    $(this).closest('.col-md-4').siblings().find(".service-cell").removeClass("triangle");
});

$('.accordion-icons-container.collapse').on('show.bs.collapse', function () {
    $("html, body").animate({ scrollTop: $(this).offset().top }, 500);

})

$('.well-close').click(function () {
    var wellCollapse = $(this).closest('.collapse.in');
    wellCollapse.collapse('hide');    

    var serviceCell = $("#" + wellCollapse.attr('id') + "_cell");
    serviceCell.removeClass("triangle");
    serviceCell.addClass("collapsed");

});

//old FM js below
/*
$('.dropdown-toggle').dropdown();


$('.strip-image-carousel').flickity({
    // options
    arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 50,
        x3: 20
    },
    autoPlay: true,
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: true

});

$('.strip-testimonial-carousel-container').flickity({
    arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 50,
        x3: 20
    },
    cellAlign: 'left',
    cellSelector: '.strip-testimonial-carousel-cell',
    contain: true,
    draggable: false,
    pageDots: false

});

$('.dropdown-menu').each(function () {
    var parentWidth = $(this).parent().innerWidth();
    var menuWidth = $(this).innerWidth();
    var margin = (parentWidth / 2) - (menuWidth / 2);
    margin = margin + "px";
    $(this).css("margin-left", margin);
});

*/


// WEBPACK FOOTER //
// ./cmsscripts/custom/main.js